import { Component, ChangeDetectionStrategy } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';

@Component({
  selector: 'app-not-found',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  constructor() {
    datadogLogs.logger.error('Not Found', {
      url: window.location.href,
    });
  }
}
